import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text && _vm.text.length > 30)?_c(VTooltip,{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('span',_vm._g(_vm._b({staticClass:"shot-text-value",on:{"click":function($event){return _vm.copyText(_vm.text)}}},'span',attrs,false),on),[_vm._v(_vm._s(_vm.text.slice(0, 30))+"...")])]}}],null,false,416241238)},[(_vm.copied)?_c('span',{staticClass:"copied-message"},[_vm._v("Full text is copied to clipboard")]):_c('span',[_vm._v(_vm._s(_vm.text))])]):_c('span',[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }